"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Spinner = _interopRequireDefault(require("./Spinner.styles"));
function Spinner() {
  var _useStyles = (0, _Spinner.default)(),
    spinner = _useStyles.spinner,
    spinnerCircle = _useStyles.spinnerCircle;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: spinner,
    viewBox: "22 22 44 44",
    role: "progressbar",
    "aria-label": "loading"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: spinnerCircle,
    cx: "44",
    cy: "44",
    r: "20.2",
    fill: "none",
    strokeWidth: "3.6"
  }));
}
var _default = Spinner;
exports.default = _default;
